package com.anjuros.website.templates.template1.sections

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.shared.AnjurosImage
import com.anjuros.website.templates.template1.components.PrimaryButton
import com.anjuros.website.templates.template1.components.SecondaryButton
import com.anjuros.website.templates.template1.components.Template1Header
import com.anjuros.website.templates.template1.modules.Template1Theme
import com.anjuros.website.templates.template1.modules.getColor
import com.anjuros.website.templates.template1.styles.Template1HeroFontSizeStyle
import com.anjuros.website.templates.template1.styles.Template1HeroHeaderStyle
import com.anjuros.website.templates.template1.util.ResKey
import com.anjuros.website.templates.template1.util.Template1Res
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template1MainSection(
    modifier: Modifier = Modifier.fillMaxWidth(),
    onMenuCLicked:()->Unit = {}){
    Box(
        modifier = modifier
            .id("home")
            .fillMaxSize()
            .maxHeight(700.px)
        ,
        contentAlignment = Alignment.TopCenter
    ) {

        AnjurosImage(
            modifier = Modifier
                .fillMaxWidth()
                .displayIfAtLeast(Breakpoint.LG),
            src = Template1Res.Image.template1_main2,
            alt = "Hairdresser image"
        )
        AnjurosImage(
            modifier = Modifier
                .fillMaxWidth()
                .displayUntil(Breakpoint.LG)
                .minHeight(400.px)
                .objectFit(ObjectFit.Cover),
            src = Template1Res.Image.template1_main_mobile,
            alt = "Hairdresser image"
        )
        Template1Hero()
        Template1Header(
            modifier = Modifier.align(Alignment.TopCenter)
        ) { onMenuCLicked() }

    }
}
@Composable
fun Template1Hero() {

    Box(
        modifier = Template1HeroHeaderStyle.toModifier()
            .fillMaxWidth()

    ) {

        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(leftRight = 36.px),
            verticalAlignment = Alignment.CenterVertically
        ) {

            Column(
                modifier = Modifier.weight(1f)
            ) {



                Template1HeroHeading()

                Spacer()

                Template1HeroParagraph()

                Spacer()

                // The two buttons wrap onto two lines on narrow phones instead of pushing the page wider.
                Row(modifier = Modifier.styleModifier { property("flex-wrap", "wrap"); property("row-gap", "12px") },
                    horizontalArrangement = Arrangement.spacedBy(18.px)) {

                    PrimaryButton(
                        text = ResKey.TEMPLATE1_HERO_BUTTON1,
                        path="#contact"

                    )



                    SecondaryButton(
                        text = ResKey.TEMPLATE1_HERO_BUTTON2,
                        path="#service"
                    )

                }

            }
        }
    }
}

@Composable
private fun Template1HeroHeading() {

    H1(
        attrs = Template1HeroFontSizeStyle.toModifier()
            .fontWeight(FontWeight.Bold)
            .color(Template1Theme.OpacityPrimary.getColor())
            .margin(topBottom = 28.px)
            .styleModifier {
                property(
                    "text-shadow",
                    "0 2px 4px rgba(255,255,255,0.25)"
                )
            }
            .toAttrs()
    ) {

        Text(LocalText(ResKey.TEMPLATE1_HERO_TITLE))

    }
}

@Composable
private fun Template1HeroParagraph() {

    P(
        attrs = Modifier
            .maxWidth(520.px)
            .fontSize(20.px)
            .displayIfAtLeast(Breakpoint.LG)
            .lineHeight(34.px)
            .color(rgb(160, 160, 160))
            .margin(bottom = 40.px)
            .toAttrs()
    ) {

        Text(LocalText(ResKey.TEMPLATE1_HERO_SUBTITLE))

    }
    P(
        attrs = Modifier
            .maxWidth(520.px)
            .fontSize(20.px)
            .displayUntil(Breakpoint.LG)
            .lineHeight(34.px)
            .color(Colors.White)
            .margin(bottom = 40.px)
            .toAttrs()
    ) {

        Text(LocalText(ResKey.TEMPLATE1_HERO_SUBTITLE))

    }
}
